module.exports = {
  language: {
    name: '简体中文',
    title: '选择语言',
    subList: [
      {
        name: 'English',
        link: 'en',
      },
      // {
      //   name: '简体中文',
      //   link: 'zh',
      // },
      {
          name: '繁體中文',
          link: 'tw',
      },
      {
        name: '日本語',
        link: 'jp',
      },
      {
        name: '한국어',
        link: 'kr',
      },
      {
        name: 'ไทย',
        link: 'th',
      },
      {
        name: 'Tiếng Việt',
        link: 'vn',
      },
      {
        name: 'Español',
        link: 'es',
      },
    ]
  },
  "user":{//mi
    "wdtd": "Mi Equipo",
    "wdyj": "Mi actuación",
    "ren": "persona",
  },
  "kjsy": {
    "title": "Ingresos",
    "fxsy": "Compartir ingresos",
    "zjlsl": "Cantidad total de la recompensa:",
    "jl": "Recompensa",
    "sj": "fecha",
    "sl": "Cantidad",
    "sm": "Descripción"
  },
  "pay":{//comprar
    "title": 'Comprar máquina de minería',
    "gmsl": 'Cantidad de compra',
    "zf": 'Pago',
    "kyye": 'Saldo disponible',
    "kyyebz": 'Saldo disponible insuficiente',
    "bztbtips": 'El monto de retiro de entrada es menor que el requisito mínimo de retiro de la moneda',
    "bztbtips2": 'El monto de retiro no puede ser inferior al monto mínimo de retiro',
    "qsrjymm": 'Ingrese una contraseña de transacción de 6 dígitos',
    "wxts": 'Recordatorio',
  },
  "chongbi": {
    "title": 'Depósito',
    "lianmc": 'Tipo de cadena',
    "scl": 'Generar cadena exclusiva',
    "sy": 'clave privada',
    "em": 'Código QR',
    "bcewm": 'Guardar el código QR',
    "cbdz": 'Dirección de depósito',
    "fz": 'Copiar',
    "sl": 'Cantidad del depósito',
    "qsrsl": 'Por favor ingrese el monto del depósito',
    "sjczje": 'Cantidad de recarga real',
    "qsrsjczje": 'Ingrese el monto real de la recarga',
    "pzms": 'Descripción del certificado',
    "qsrms": 'Ingrese una descripción',
    "hxz": 'valor hash',
    "qsrhxz": 'Por favor ingrese el valor hash',
    "pztp": 'Imagen del cupón',
    "qscpztp": 'Cargue la imagen del certificado',
    "fzcg": 'Copia exitosa',
    "yhkcz": 'Recarga de tarjeta bancaria',
    "usdtcz": 'Recarga USDT',
    "btccz": 'Recarga BTC',
    "xzbz": 'Seleccionar moneda',
    "sure": 'Confirmar',
    "ck": 'Ver',
    "tips1": "Por favor, no ingrese ningún activo que no sea en moneda local en la dirección mencionada o los activos no se recuperarán",
    "tips2": "1. Compatibilidad de billetera / plataforma: es decir, la red es compatible, si la plataforma de destino no es compatible con su red de retiro, los activos no se pueden recuperar.",
    "tips3": "2. Su red de recarga y la plataforma de destino son la misma, si elige la dirección de destino es la red Ethereum, pero la recarga elige la cadena inteligente TRC20, es posible que no pueda recuperar sus activos digitales.",
    "tips4": "3. Asegúrese de que su dirección y la cantidad sean correctas antes de recargar.",
    "tips5": "Recordatorio: debido al anonimato y la privacidad de la red de bloques, una vez que ingrese la información incorrecta, perderá los activos correspondientes. Comprueba cuidadosamente tu dirección de recarga y la cantidad."
  },
  "usdttb":{
    "title": 'Retirar monedas',
    "lmc": 'Tipo de cadena',
    "xzl": 'Seleccionar cadena',
    "xztbdz": 'Seleccionar dirección de retiro',
    "qsrtbdz": 'Ingrese la dirección de retiro',
    "tbdz": 'Dirección de retiro',
    "qsrdz": 'Por favor ingrese la dirección',
    "tbsl": 'Cantidad de retiro',
    "tbsl2": 'Cantidad de retiro:',
    "qsrtbsl": 'Ingrese el monto del retiro',
    "sjtxje": 'Cantidad real de retiro',
    "qsrsjtxje": 'Ingrese el monto real del retiro',
    "dzje":'Cantidad recibida',
    "jymm": 'Contraseña de transacción',
    "qsrjymm": 'Por favor ingrese la contraseña de la transacción',
    "sxf": 'tarifa de manejo',
    "qsrsxf": 'Ingrese la tarifa de manejo',
    "dzsl": 'Importe de la cuenta',
    "dzsl2": 'Cantidad de cuenta recibida:',
    "qsrdzsl": 'Por favor ingrese el monto de la cuenta',
    "wxts": 'Recordatorio:',
    "mrzdtxcs": 'Cantidad mínima de retiro cada vez:',
    "hxxf": 'Necesidad de consumir',
    "cktx": 'Solo disponible para retiro',
    "ci": 'tiempos',
    "wddtxyq": 'Requisitos de retiro no cumplidos',
    "tjcg": 'Envío exitoso, espere la revisión',
    "tips": 'Puedes retirar monedas solo si tu propia potencia informática es superior a 1T (excepto si tienes experiencia con la potencia informática de la máquina de minería) o si la potencia informática bajo el paraguas es superior a 50T. ',
    "dz": 'dirección',
    "qd": 'OK',
    "zdtb": "Retiro mínimo"
  },
  "kefu": {
    "title":'Contactar con el servicio de atención al cliente',
    "zxkf":'Servicio al Cliente',
    "fzcg":'Copia exitosa'
  },
  "xgdlmm":{//Modificar contraseña de inicio de sesión
    "title":'Cambiar contraseña de inicio de sesión',
    "t1":'Contraseña de inicio de sesión actual',
    "t2":'Ingrese la contraseña de inicio de sesión actual',
    "t3":'Nueva contraseña',
    "t4":'Ingrese de 6 a 16 dígitos y letras',
    "t5":'Confirmar contraseña',
    "t6": 'Ingrese de 6 a 16 dígitos y letras',
    "t7":'Confirmar',
    "t8":'La contraseña es inconsistente con la contraseña de confirmación'
  },
  "sztxmm":{//Establecer la contraseña de retiro
    "title":'Cambiar contraseña de transacción',
    "wjtkmm": 'Olvidé la contraseña de la transacción',
    "qsrjdlmm":'Ingrese la contraseña de transacción actual',
    "zh": 'Cuenta',
    "qsryxhzsj": 'Ingrese su dirección de correo electrónico o teléfono móvil',
    "t1":'Contraseña de transacción actual',
    "t2":'Nueva contraseña de transacción',
    "t3":'Ingrese una contraseña de transacción de 6 dígitos',
    "t4":'Confirmar contraseña',
    "t5":'¿Olvidó la contraseña de la transacción? ',
    "t6":'Confirmar',
    "t7": 'La contraseña es inconsistente con la contraseña de confirmación',
    "t8":'Contraseña de transacción',
    "yzm": 'Código de verificación',
    "qsryzm": 'Por favor ingrese el código de verificación',
    "hqyzm": 'Obtener código de verificación'
  },
  "record": {
    "cbjl": 'Registro de depósito de monedas',
    "tbjl": 'Registro de retiro',
    "status":"['Sin revisar', 'Aprobado', 'Rechazado']",
    "bhly": 'Motivo del rechazo',
    "ldz": 'Dirección:',
    "cjsj": 'Hora de creación:',
    "zzsj": 'Tiempo de transferencia:',
    "czl": 'Cadena de recarga:',
    "zrl": 'Cadena de transferencia:',
    "jyhx": 'Hash de transacción:'
  },
  "yqm": {
    "wdyqlj": 'Mi enlace de invitación',
    "wdyqm": 'Mi código de invitación',
    "schbyq": 'Generar cartel de invitación',
    "bctp": 'Guardar imagen',
    "qx": 'Cancelar',
    "fx": 'Compartir',
    "yqm": 'Copiar código de invitación',
    "bcewmdxc": 'Guarda el código QR en el álbum de fotos',
    "bcbd": 'Guardar localmente'
  },
  "wdtd": {
    "title": 'Mi equipo',
    "td": 'Equipo',
    "yqhy": 'Invitar amigos',
    "ren": 'persona',
    "wdtdzrs": 'El número total de mi equipo',
    "uid": 'UID:',
    "zh": 'Cuenta:',
    "tdrs": 'Tamaño del equipo:',
    "zcsj": 'Fecha de registro:'
  },
  "wdyj": {
    "title": 'Mi rendimiento',
    "wdyd": 'Mi Generación',
    "dyj": 'Rendimiento',
    "tdzyj": 'Rendimiento total del equipo',
    "uid": 'UID:',
    "tdrs": 'Tamaño del equipo:',
    "yj": 'Rendimiento:'
  },
  "zc": {
    "title": 'Activos',
    "zzczh": 'equivalente de activos totales',
    "dh": 'Intercambio',
    "yczc": 'Activos ocultos como 0',
    "xj": 'precio actual',
    "zh": 'Convertido',
    "zcmx": 'Detalles del activo',
  },
  "duihuang": {
    "title": 'Intercambio',
    "hl": 'Tipo de cambio',
    "zf": 'Pago',
    "qbdh": 'Intercambiar todo',
    "ky": 'Disponible',
    "dd": 'Obtener',
    "ljdh": 'Canjear ahora',
    "cont": 'Cambios en el tipo de cambio, sujeto a la cantidad real recibida',
    "yebz": 'Saldo insuficiente',
    "ksslbz": 'Cantidad insuficiente disponible',
    "qtxje": 'Por favor ingrese la cantidad',
    "dhcg": 'Intercambio exitoso',
    "mrcg": 'Compra exitosa',
    "mccg": 'vendido con éxito',
    "wtcg": 'Delegación exitosa',
    "ts": 'Aviso',
    "btcmTips": 'De acuerdo con la configuración del contrato inteligente, el intercambio GDCC USDT comenzará el 8 de agosto de 2023. ',
    "qx": 'Cancelar'
  },
  "sign": {
    "title": 'Iniciar sesión para recibir monedas',
    "title2": 'Recompensa de inicio de sesión diario',
    "title3": 'Iniciar sesión como recompensa',
    "qd": 'Iniciar sesión',
    "yqd": 'Iniciar sesión',
    "hdgz": 'Reglas de eventos',
    "qdjl": 'Registro de entrada',
    "qdcg": 'Iniciar sesión correctamente'
  },
  "langNew": {
    "wd": "Mi",
    "jd": "Préstamo",
    "jghy": "Futuros",
    "xbsg": "Compra de moneda de Singapur",
    "sylx": "Tipo de beneficio",
    "syts": "Días de ganancias: ",
    "rsy": "Ingreso diario:",
    "rsy2": "Ingreso diario",
    "yjdts": "Número de días prestados: ",
    "jdsy": "Ingresos por préstamos:",
    "jdsy2": "Ingresos por préstamos",
    "jdrq": "Fecha del préstamo: ",
    "qdsy": "Beneficios de iniciar sesión",
    "tgsy": "Beneficio de promoción",
    "sybl": "Relación de beneficio",
    "sybl2": "Relación de beneficio: ",
    "ljcy": "Únete ahora",
    "zsy": "Ingresos totales",
    "jdrz": "Nodo de enlace",
    "jiedian": "nodo",
    "qsrje": "Por favor ingrese un nodo",
    "xyb": "Siguiente",
    "zhye": "Saldo de la cuenta",
    "dzye": "Saldo de direcciones",
    "zhyezh": "Saldo de la cuenta (equivalente)",
    "zq": "Período: ",
    "zq2": "punto",
    "jdsl": "Monto del préstamo",
    "yxbd": "Verificar correo electrónico",
    "qsryxzh": "Por favor ingresa tu cuenta de correo electrónico",
    "yxgz": "La dirección de correo electrónico ingresada no cumple con las reglas",
    "jxz": "En progreso",
    "ywc": "Completado",
    "day": "días",
    "jg": "Precio: ",
    "zwsj": "Sin datos~",
    "wyjb": "Pedir prestado",
    "fxjl": "Compartir recompensa",
    "aqsz": "Configuración de seguridad",
    "wded": "Mi segunda generación",
    "wdsd": "Mis tres generaciones",
    "dbxe": "Límite de transacción única",
    "tjdd": "Enviar pedido",
    "tqsh": "Retirar canje: ",
    "shuhui": "Redención",
    "ljdz": "Dirección del enlace",
    "yyqh": "Cambio de idioma",
    "zxkf": "Servicio al cliente",
    "syl": "Regreso diario",
    "zhuanbi": "Gana monedas",
    "zbsy": "Obtener ingresos en divisas",
    "mc": "Nombre",
    "zxj": "Último precio",
    "zfb": "Lista en ascenso",
    "shouye": "Página de inicio",
    "gg": "Anuncio",
    "rzz": "Certificando",
    "yrz": "Autenticado",
    "rzsb": "Error de autenticación, vuelva a autenticarse",
    "cxrz": "Reautenticación",
    "jymmts": "Vaya a la configuración de seguridad para establecer la contraseña de la transacción"
  },
  "xbsg":{
    "title": "Moneda nueva",
    "wdsg": "Detalles",
    "scts": "Días de encierro: ",
    "sy": "restante",
    "ljsg": "Suscríbase ahora",
    "ysk": "Vendido",
    "xzjdy": "Suscríbase ahora",
    "dy": "Suscribir",
    "fxjg": "precio de emisión",
    "fxl": "Circulación",
    "ssrq": "Fecha de cotización",
    "yxqx": "Período de validez",
    "qsrsl": "Por favor ingrese la cantidad",
    "syl": "restante",
    "sgrq": "suscribir",
    "sgsl": "Monto",
    "bz": "Moneda",
    "yebz": "Saldo de USDT insuficiente",
    "tgsl": "Cantidad de pases",
    "shz": "bajo revisión",
    "wtg": "No pasó",
    "ytg": "aprobado"
  },
  "wydb":{
    "title": "Pedir prestado",
    "db": "Pedir prestado",
    "dbz": "Pedir prestado",
    "jl": "registro",
    "jdzq": "Período (días)",
    "qhk": "Volver a pagar",
    "ljdb": "Acumulativo",
    "dhkbs" :"pago pendiente",
    "jkje": "cantidad",
    "qsrje": "Por favor ingrese la cantidad",
    "rll": "Tasa de interés diaria",
    "hkfs": "Reembolso",
    "dqych": "Caducado",
    "lx": "Interesar",
    "fkjg": "Prestador",
    "tpsc": "Préstamo de crédito (carga de imagen)",
    "fwxx": "Información de vivienda",
    "srzm": "Comprobante de ingresos (relación laboral)",
    "yhmx": "Extracto de cuenta",
    "zjz": "foto de identificación",
    "yd": "He leído y estoy de acuerdo",
    "xy": "Solicitar un acuerdo de préstamo",
    "sqdb": "solicitar cadenas de préstamo",
    "gb": "cierre",
    "qd": "OK",
    "ts": "Por favor marque Solicitar un acuerdo de préstamo",
    "dbjl": "registro",
    "hkhth": "Código de orden",
    "wsh": "sin revisar",
    "yfk": "Préstamo",
    "sqrq": "tiempo de aplicación",
    "zq": "ciclo",
    "dbsl": "Monto",
    "zhke": "Pago total",
    "yhkxq": "Detalles de reembolso",
    "bqyhk": "Reembolsable en el período actual(USDT)",
    "hktips": "Asegúrese de que el saldo sea suficiente, si el saldo es insuficiente, recargue primero y luego pague",
    "bj": "Principal",
    "jie": "Pedir prestado",
    "ljhk": "pagar inmediatamente",
    "qcz": "Depositar",
    "yebzqxcz": "Saldo insuficiente, recargue primero y luego pague",
    "znj": "cargo del pago atrasado",
    "yqts": "Dias atrasados"
  },
  "hkxq":{
    "dd":"Pedido",
    "fzhkdz":"Copia la dirección de pago",
    "hkxq": "Detalles de reembolso",
    "zlx": "interés total",
    "zhk": "reembolsos totales",
    "hkjg": "agencia de pago",
    "qschkpz": "Cargue el certificado de reembolso",
    "hkpz": "certificado de reembolso"
  },
  "kxt": {
    "gao":"H",
    "di":"L",
    "wtgd": "Orden pendiente",
    "cj": "Transacción",
    "jj": "Información",
    "sj": "Hora",
    "fx": "Dirección",
    "jg": "Precio",
    "sl": "Importe",
    "mr": "Comprar",
    "mc": "Vender",
    "mp": "Oferta",
    "sp": "Venta",
    "slb": "Importe",
    "fhsj": "Hora de salida",
    "fhsl": "Número de edición",
    "bps": "Papel blanco",
    "gw": "Sitio web oficial",
    "yue": "Mes",
    "ft": "Imagen lateral",
    "zt": "Imagen principal",
    "sdt": "Profundidad",
    "zx": "Opcional",
    "djck": "Click para ver"
  },
  "jghy": {
    "jghy": "Futuros",
    "yxhy": "Contrato perpetuo",
    "mz": "Comprar largo",
    "md": "Vender en corto",
    "gmj": "Precio de compra",
    "jsj": "Precio de liquidación",
    "xj": "Precio actual",
    "fx": "Dirección",
    "sl": "Importe",
    "jgsj": "Hora de entrega",
    "gb": "Cerrar",
    "jxxd": "Continuar con el pedido",
    "cclb": "Lista de pedidos",
    "zc": "Actualidad",
    "lscc": "Historia",
    "qblx": "Todos los tipos",
    "yk": "Beneficios y pérdidas",
    "ddqr": "Confirmación de pedido",
    "dqsj": "Hora de caducidad",
    "jssj": "Hora de entrega",
    "sy": "Beneficio",
    "tzje": "Precio de la inversión",
    "zdje": "Precio más bajo 0",
    "kyye": "Equilibrio",
    "kyye2": "Equilibrio: ",
    "sxf": "Tarifa: ",
    "sxfl": "Tarifa",
    "jypz": "nombre",
    "jyfx": "Dirección",
    "qrxd": "Confirmar",
    "dqye": "Saldo actual"
  },
  "zhjl": {
    "title": "Historial de activos",
    "cbtb": "Depósito y retirada",
    "jymx": "Historial de transacciones",
    "tgyj": "Comisión de promoción",
    "wwc": "Se acabó",
    "ywc": "Completado"
  },
  "tipsNew":{
    "wjmmts": "Recuperar contraseña por código de verificación",
    "qscpztp": "Carga de la imagen del cupón",
    "emailgsts": "Por favor introduzca una dirección de correo electrónico válida",
    "telgsts": "El número de teléfono móvil es incorrecto.",
    "lcmmbyz": "Bitte bestätigen Sie Ihr Passwort",
    "zdsl": "Mínimo ",
    "sldydy": "Cantidad mayor o igual a",
    "zxtzsl": "Mínimo ",
    "ddz": "Esperando",
    "xs": "Hora",
    "min": "Monto minimo ",
    "max": "Cantidad máxima ",
    "yebz": "Saldo insuficiente",
    "qsrss": "Por favor ingrese el lote",
    "zdss": "Lotes mínimos",
    "yjj": "rechazado",
    "shz": "redención",
    "zwkfcz": "Esta moneda aún no está abierta para recarga",
    "jiaoge": "Entrega",
    "zhang": "levantarse",
    "die": "otoño",
  },
  "assets": {
    "total": "Conversión de activos",
    "avaiable": "disponible",
    "conversion": "Conversión",
    "canuse": "disponible",
    "yczc":"Activos ocultos como 0"
  },
  "status": {
    "statusText": ['fracaso','esperando','éxito'],
  },
  "langNew2":{
    "zczgz": "Los activos totales",
    "hgx": "Cumplimiento",
    "yszc": "Política de Privacidad",
    "gywm": "Acerca de nosotros",
    "zb": "Cuantificación de IA",
    "mnjy": "Negociación simulada",
    "xbzq": "Zona monetaria de Singapur",
    "flzq": "Centro de recompensas",
    "cjmnzhcg": "¡Crea una cuenta de demostración con éxito!",
    "wdzh": "Mi cuenta",
    "yymnzhts": "Ya tengo una cuenta virtual, por favor no se registre de nuevo",
    "tcmnzh": "Salir de la cuenta de demostración",
    "mnzhgz": "Valoración de cuenta demo",
    "mnzh": "Cuenta Demo",
    "ljdzsb": "No se pudo conectar a la dirección",
    "ysq": "Autorizado"
  },
  "c2c":{
    "bt": "P2P",
    "bt2": "Servicio de pago P2P",
    "cjdd": "Crear orden",
    "mblc": "Depósito en moneda fiduciaria",
    "cjydd": "Crear un pedido anticipado",
    "xmjfk": "Pagar al vendedor",
    "tqhb": "Retira tu moneda digital",
    "ddzt": "Estado del pedido",
    "wdys": "Nuestras ventajas",
    "c1": "Negocia a tu precio preferido",
    "c2": "Compre y venda criptomonedas libremente a su precio preferido. Compre y venda ofertas existentes o cree un anuncio comercial para establecer su precio ideal.",
    "c3": "Tarifa de transacción baja",
    "c4": "Las transacciones peer-to-peer (P2P) permiten a los vendedores definir libremente el método de pago que desean de forma transparente, comprando y vendiendo criptomonedas a través de más de 700 métodos de pago, incluidas transferencias bancarias y efectivo.",
    "c5": "Múltiples métodos de pago",
    "c6": "El comercio entre pares (P2P) permite a los vendedores definir libremente el método de pago que desean. Compre y venda criptomonedas con más de 700 métodos de pago, incluidas transferencias bancarias y efectivo.",
    "wpp": "No coincide",
    "ypp": "Coincidente",
    "ysx": "Caducado",
    "ddh": "Número de pedido",
    "mrje": "Cantidad de compra",
    "mrbz": "Comprar moneda",
    "nssdgj": "País",
    "qsrnssdgj": "Por favor ingrese el país",
    "fkrxm": "Nombre del pagador",
    "qsrfkrxm": "Por favor ingrese el nombre del pagador",
    "yx": "Correo electrónico",
    "qsryx": "Por favor ingrese su dirección de correo electrónico",
    "mmbz": "Tipo de compra",
    "qxzmmbz": "Por favor seleccione el tipo de compra",
    "qxz": "Por favor seleccione",
    "fkfs": "Método de pago",
    "qtxfkfs": "Por favor complete el método de pago",
    "zh": "Cuenta",
    "fb": "Tipo de moneda de pago",
    "qtxfb": "Por favor complete el tipo de moneda de pago",
    "ngmdje": "Monto de tu compra",
    "qsrje": "Por favor ingresa el monto",
    "wxts": "Recordatorio cálido:",
    "dsh": "Por revisar",
    "ygq": "Caducado",
    "jcwdwt": "Introducción a P2P",
    "tjpz": "Enviar comprobante",
    "ckje": "Monto del partido",
    "qsrckje": "Por favor ingrese el monto correspondiente",
    "tjzzfb": "Transferir copia",
    "tjjzzm": "Tarjeta de identificación (frente)",
    "tjjzfm": "Tarjeta de identificación (reverso)",
    "psts1": "Presta atención a los siguientes puntos al disparar",
    "psts2": "Tenga en cuenta que el borde de la imagen está completo, la fuente es clara y el brillo es uniforme",
    "psts3": "Por favor, no cargue fotos de identificación que no coincidan con su nombre",
    "qsczzfb": "Por favor cargue una copia de la transferencia",
    "qscjzzm": "Por favor cargue el frente de su licencia de conducir",
    "qscjzfm": "Por favor cargue el reverso de su licencia de conducir",
    "tj": "Enviar",
    "je": " Rango límite",
    "ljtg": "Realizar pedido",
    "sp": "Comprender DeFi",
    "xq": "Detalles",
    "lxkfppdd": "Contacte con servicio al cliente para igualar el pedido",
    "szgj": "País",
    "qsrszgj": "Por favor ingresa tu país",
    "fkyhmc": "Nombre del banco de pago",
    "qsrfkyhmc": "Por favor ingrese el nombre del banco de pago",
    "dianhui": "Transferencia bancaria/Transferencia bancaria internacional",
    "ccsr": "Ingrese aquí"
  },
  "xyf":{
    "title": "Puntaje de credito",
    "pgsj": "Tiempo de evaluación"
  },
  "bbjy": {
    "mr": "Comprar",
    "mc": "Vender",
    "mai": "Comprar",
    "sell": "Vender",
    "xj": "Límite",
    "sj": "Mercado",
    "pk": "Handicap",
    "jg": "Precio",
    "sl": "Importe",
    "mrl": "Volumen de compra",
    "ss": "Importe",
    "mcl": "Volumen de venta",
    "ky": "Disponible",
    "km": "Disponible",
    "ksell": "Mercado",
    "jye": "Venta",
    "dqwt": "Ordenes abiertas",
    "lswt": "Historial de ordenes",
    "jj": "Información",
    "wtzl": "Total",
    "wtjg": "Precio de la comisión",
    "ycjl": "Volumen de negociación completado",
    "cjjj": "Precio medio de la transacción",
    "cd": "Retirar fondos",
    "xd": "Hacer pedido",
    "ywc": "Completado",
    "ycd": "Retirado",
    "wqcj": "Transacción completada",
    "zx": "Opcional",
    "scjg": "Precio de mercado",
    "fhsj": "Hora de salida",
    "fhsl": "Número de edición",
    "bps": "Papel blanco",
    "gw": "Sitio web oficial",
    "qx": "Cancelar",
    "bbjy": "Intercambio"
  },
  "hyjy": {
    "mai": "Comprar",
    "sell": "Vender",
    "kc": "Abrir posiciones",
    "pc": "Cerrar posición",
    "cc": "Posiciones",
    "kp": "Cerrar",
    "kpc": "Cerrar corto",
    "kcc": "Posiciones",
    "kkd": "Abrir largo",
    "kpd": "Cerrar largo",
    "kkk": "Abrir corto",
    "xj": "Límite",
    "sj": "Precio de mercado",
    "xjwt": "Orden precio limitado",
    "sjwt": "Precio de mercado",
    "pk": "Handicap",
    "jg": "Precio",
    "sl": "Importe",
    "gg": "Apalacamiento",
    "tzgg": "Ajustar apalancamiento",
    "ggbs": "Apalacamiento",
    "mrl": "Volumen de compra",
    "ky": "Disponible",
    "jye": "Venta",
    "dqwt": "Ordenes abiertas",
    "lswt": "Historial de ordenes",
    "ptwt": "Orden ordinaria",
    "dqwtmr": "Orden actual (Compra)",
    "dqwtmc": "Orden actual (Venta)    ",
    "hywt": "Orden contractual",
    "jj": "Información",
    "wtzl": "Total",
    "wtjg": "Precio de la comisión",
    "ycjl": "Volumen de negociación completado",
    "cjjj": "Precio medio de la transacción",
    "cd": "Retirar fondos",
    "xd": "Hacer pedido",
    "wqcj": "Transacción completada",
    "ywc": "Completado",
    "ycd": "Retirado",
    "zx": "Opcional",
    "scjg": "Precio de mercado",
    "fhsj": "Hora de salida",
    "fhsl": "Número de edición",
    "bps": "Papel blanco",
    "gw": "Sitio web oficial",
    "mrzd": "Comprar largo",
    "mrpk": "Comprar corto ",
    "mczk": "Vender corto ",
    "mcpd": "Vender largo",
    "mrkdkz": "Comprar al abrir (alcista)",
    "mrpkkz": "Comprar al cierre (alcista)",
    "mckkkd": "Vender al abrir (bajista)",
    "mcpdkd": "Vender al cierre (bajista)",
    "yxhy": "Contrato perpetuo",
    "dc": "Posiciones largas",
    "syl": "Tasa de rendimiento",
    "bzjl": "Tasa de margen",
    "tzbzj": "Ajuste del margen",
    "zyzs": "Toma de beneficios y stop-loss",
    "zhang": "Importe",
    "qblx": "Todos los tipos",
    "qb": "Todos",
    "ccjg": "Precio de la posición",
    "ccsl": "Cantidad de la posición",
    "yk": "Beneficios y pérdidas",
    "ccsj": "Tiempo de la posición",
    "zy": "Toma de beneficios",
    "zs": "Stop-loss",
    "zje": "Importe total",
    "kcs": "Cantidad de la posición abierta",
    "kcjg": "Precio de la posición abierta",
    "ss": "Lotes",
    "hand": "1 lote =",
    "qx": "Cancelar",
    "qr": "Confirmar",
    "qbcd":"Cancelar todos los pedidos"
  },
  "bbjyNew":{
    "jylx": "Tipos de",
    "jyze": "Cantidad"
  },
  "langNew3":{
    "bzxq": "Detalles de los ladrillos en movimiento",
     "znbz": "Movimiento de ladrillos inteligente cuantitativo con IA",
     "apits": "Conéctese sin problemas a las API de más de 200 intercambios en todo el mundo",
     "jr": "Unirse",
     "gn": "Función",
     "lhjs": "Introducción a la cuantificación de dividendo",
     "jqrts": "¿Cómo funcionan los robots?",
     "sctj": "Estadísticas de mercado",
     "scqk": "Condiciones del mercado",
     "jiaoge": "Entrega",
     "zhang": "Levántate",
     "die": "Caer",
     "sz": "Configuración",
     "qbcp": "Todos los productos",
     "jrlh": "Únase a la cuantificación de la IA",
      "sywd": "0 riesgo, rentabilidad estable",
      "bzbz": "Tipo criptográfico"
  },
  "sztkmm": {
    "title": "Establezca la contraseña de retirada",
    "dlmm": "Contraseña de acceso ",
    "dlmmts": "Introducir la contraseña de acceso",
    "xmm": "Nueva contraseña",
    "mmts": "Longitud de la contraseña 6 dígitos",
    "qrmm": "Confirmar contraseña",
    "qr": "Confirmar",
    "qd": "ACEPTAR",
    "sztkts": "Consejo: Por favor, vaya al Centro de Seguridad para establecer la contraseña de la transacción"
  },
  "bzhl": {
    "title": "Dividendo",
    "gz": "Reglas",
    "tgdd":"Orden de depósito en garantía",
    "zztgdzj":"Fondos bajo custodia",
    "yjjrsy":"Diario estimado",
    "ljsy":"Ingresos totales",
    "tgzdd":"Orden de custodia",
    "cljxcp":"Productos estratégicos de campaña",
    "dbxe": "Límite",
    "rsyl":"Tasa de rendimiento diaria",
    "zq":"Ciclo de pedidos",
    "qmr":"Ve y compra",
    "bbzhzc": "Activos de la cuenta",
    "zcc": "Activos totales(USDT)",
    "dd": "Pedidos",
    "buy": "Comprar",
    "jxcp":"Productos destacados",
    "ckdd":"Consultar pedido",
    "gd":"más",
    "xzbzts": "Simple y seguro. Los dividendos se pueden seleccionar en múltiples monedas",
    "qtbz": "Otras monedas",
    "dj": "Nivel",
    "cjwt": "Problemas comunes",
    "ddsl": "Cantidad del pedido",
    "sl": "Cantidad"
  },
  "bzhlgm": {
    "qtzq": "Ciclo de 7 días de USDT",
    "rsyl": "Tasa de devolución diaria",
    "lczq": "Ciclo financiero",
    "dbxe": "Límite único ",
    "pxsj": "Calendario de pago de dividendos",
    "mr": "Diario",
    "dqfh": "Retorno a vencimiento",
    "tgzj": "Capital en custodia",
    "tqsh": "Retorno anticipado",
    "yjsy": "Ingresos anticipados (USDT)",
    "kyzc": "Activos disponibles (USDT)",
    "cpjs": "Acerca de nuestros productos",
    "tgje": "Importe de la custodia",
    "qsrtgje": "Por favor, introduzca el importe de la custodia",
    "qb": "Todos",
    "rm": "Haga clic aquí",
    "cpzq": "Ciclo del producto",
    "gz": "Conozca las reglas y los intereses"
  },
  "bzhlwdtg": {
    "title": "Estado del pedido",
    "tgz": "Bajo custodia",
    "ywc": "Completado",
    "ysh": "Canjeado",
    "tgje": "Monto de custodia/Tiempo de custodia",
    "rsyl": "Rata de regreso diario",
    "yhl": "Beneficiado",
    "xdsj": "Hora de realizar el pedido",
    "sh": "Redención",
    "ddxq": "Detalles del pedido",
    "ddh": "Nº de pedido",
    "syts": "Restante",
    "ddztxq": "Detalles del estado del pedido"
  },
  "langNew4":{
    "kp": "Apertura",
    "zuoshou": "recibido ayer",
    "zg": "más alto",
    "zd": "más bajo",
    "dqjg": "Precio actual",
    "pcjg": "Precio de cierre",
    "gd": "orden pendiente",
    "gdj": "Precio del pedido pendiente",
    "gdjg": "Precio del pedido pendiente",
    "xfbzj": "Depósito de seguridad requerido: ",
    "ksrfw": "Rango de entrada disponible: ",
    "shou": "Lotes",
    "fdjyk": "ganancias y pérdidas netas flotantes",
    "pcsl": "Cantidad de cierre",
    "cx": "revocar",
    "qrpc": "Confirmar para cerrar la posición",
    "sx": "filtrar",
    "cz": "reiniciar",
    "zdl": "sabía",
    "kccg": "¡Abrió con éxito una posición!",
    "xzfx": "elegir dirección",
    "lx": "tipo",
    "xgcc": "modificar posición",
    "szzyzs": "Establecer stop loss y stop loss",
    "szhb": "criptomoneda",
    "gjs": "Metal",
    "yy": "Crudo",
    "jy": "Comercio",
    "gp": "Existencias",
    "jmhb": "criptomoneda",
    "gdsj": "Tiempo de pedido pendiente",
    "gdsl": "Cantidad de pedido pendiente",
    "fs": "time"
   },
   "deals": {
    "issue_time": "Hora de salida",
    "issue_number": "Número de edición",
    "white_book": "Papel blanco",
    "weburl": "Sitio web oficial",
    "video_url": "Vídeo",
    "introduction": "Información",
    "onhand": "Lote =",
    "position": "Posición",
    "leverorder": "Pedidos apalancados",
    "leverposition": "Posición de apalancados",
    "inputprice": "Precio de entrada",
    "inputmul": "Múltiple de entrada",
    "selectmul": "Elija el múltiplo",
    "onehand": "Lote =",
    "hand": "Lotes de negociación",
    "marketval": "Valor de mercado",
    "bond": "Bono",
    "balance": "Saldo",
    "type": "Tipo",
    "risk": "Tipo de riesgo",
    "total": "Beneficio total",
    "onekey": "Liquidar con un clic",
    "makemore": "(Largo)",
    "makeless": "(Corto)",
    "current": "Ordenes abiertas",
    "all": "Todos",
    "weing": "Ordenes en curso",
    "tding": "En transacción",
    "ping": "Cerrando posición",
    "pied": "Posición cerrada",
    "ceiled": "Retirado",
    "weprice": "Precio de la orden",
    "oprice": "Precio de apertura",
    "nowprice": "Precio actual",
    "zyprice": "Precio de toma de beneficios",
    "zsprice": "Precio stop-loss",
    "canbond": "Margen disponible",
    "optime": "Hora de apertura",
    "pgtime": "Hora de cierre",
    "znum": "Cantidad convertida",
    "gprice": "Cargos nocturnos",
    "pcang": "Cerrar posición",
    "revoke": "Retirar fondos",
    "fee": "Tarifa",
    "you": "Precio óptimo de mercado"
  },
  "zyzs": {
    "title": "Toma de beneficios y stop-loss",
    "zy": "Toma de beneficios",
    "zs": "Stop-loss",
    "qsrzyjg": "Por favor, introduzca un precio de toma de beneficios",
    "qsrzsjg": "Por favor, introduzca un precio de stop-loss",
    "scjg": "Precio de mercado",
    "wxts": "Recordatorio",
    "qr": "Confirmar"
  },
  "ssbt":{
    "ssbt":"Subvenciones fiscales",
    "ssnhm":"Número de Seguro Social",
    "qsrssnhm":"Por favor ingrese su número de SSN",
    "idzmz":"Foto frontal de identificación",
    "qscidzmz":"Por favor, sube una foto del frente de tu identificación.",
    "dhfb":"Copia de transferencia bancaria",
    "qscdhfb":"Por favor, cargue una copia de su transferencia bancaria",
    "srlyfb":"Copia de fuentes de ingresos",
    "qscsrlyfb":"Por favor, cargue una copia de su fuente de ingresos.",
  },
  "newReg":{
    "sjh": "teléfono móvil",
    "yx": "Email",
    "yqm": "Código de invitación",
    "yqm2": "Código de invitación (opcional)",
    "cjzh": "Crear una cuenta",
    "sysjhzyx": "Número de móvil / registro de correo electrónico",
    "sj": "Móvil",
    "yhxy": "&lt;Acuerdo de usuario&gt;",
    "yhxy2": "He leído y acepto el &lt;Acuerdo de usuario&gt;",
    "hmyzh":"¿Todavía no tiene una cuenta?",
    "qzc":"Regístrese",
    "qbdl": "Inicio de sesión de billetera",
    "qyqbfw": "Utilice la aplicación de billetera para acceder",
    "dc": "Cerrar sesión"
  },
  "langNew5":{
    "dl": "Iniciar sesión",
    "ljdz": "Vincular dirección de billetera",
    "srdz": "Ingresar dirección",
    "ljqq": "Solicitud de conexión",
    "qq": "Solicitar",
    "qb": "Wallte",
    "ckyehhd": "Ver saldo y actividad",
    "qqjypz": "Solicitar aprobación de transacciones",
    "cro": "Cronos",
    "jj": "Rechazar",
    "lj": "Conectar",
  }
}



// WEBPACK FOOTER //
// ./src/utils/lang/xby.js